<template>
  <div style="height:100%">
    <div class="task_filter1">
      <div class="task-filter__arrow-up"></div>

      <div class="task-filter__header">
          <h4>Filters    </h4>
      </div>
      <div class="task-filter__body">
        <div>
          <div class="row ">
            <div class="col-md-12  form-group" style="padding-bottom:15px;">
              <div class="col-md-6" style="padding-right:5px;">
                <label>Time Off Code</label>
                <ob-select2 :options="LeaveOptions" :inModal="true"  v-model="Type"></ob-select2>
              </div>
              <div class="col-md-6 pL0">
                <label>Authorized Person</label>
                <ob-select2 :options="AuthOptions" :inModal="true" v-model="AuthorizedPerson"></ob-select2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group " style="padding-bottom:15px;">

              <div class="col-md-6">
                <label>Leave Applied</label>
                <div class="row">
                    <div class="col-md-6"><ob-date-time-picker ref="CreatedFromDate" v-model = "this.CreatedFromDate" class="offer-input" id="CreatedFromDate" placeholder="From date" :inputvalue="CreatedFromDate" :options="datePickerOptions" @updated="(v) => this.CreatedFromDate = v" :dpchange="onCreatedFrom"></ob-date-time-picker></div>
                    <div class="col-md-6"><ob-date-time-picker ref="CreatedToDate" class="offer-input" v-model = "this.CreatedToDate" id="CreatedToDate" placeholder="To date" :inputvalue="CreatedToDate" :options="datePickerOptions" @updated="(v) => this.CreatedToDate = v"></ob-date-time-picker></div>
                </div>
               </div>
              <div class="col-md-6">
                <label>Leave Status</label>
                <div>
                  <div class="radio-inline pL0"><ob-radio name="options1" val="Approved" v-model="Status">Approved</ob-radio></div>
                  <div class="radio-inline pL0"><ob-radio name="options1" val="Pending"  v-model="Status">Pending</ob-radio></div>
                  <div class="radio-inline pL0"><ob-radio name="options1" val="Rejected" v-model="Status">Rejected</ob-radio></div>
                  <div class="radio-inline pL0"><ob-radio name="options1" val="Revoked"  v-model="Status">Revoked</ob-radio></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row task-filter__footer">
          <ob-button type="secondary" @click="cancelAppliedFilters">Cancel</ob-button>
          <ob-button type="primary" @click="applyFilter">Apply</ob-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
   props:["AuthPerson","LeaveType"],
     data(){
    return{
        isFilterApplied : false,
         CreatedFromDate:'',
         CreatedToDate:'',
         Type :'',
         Status:'',
         AuthorizedPerson:'',
         datePickerOptions: {
         format: 'MM/DD/YYYY'
      },

      AuthOptions: {
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [

        ]
      },
      LeaveOptions: {
      placeholder: {
        id: "-1",
        text: "Select"
      },
      data: [

      ]
    },
      datePickerOptions: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
            }
        },
    }
  },
   computed: {
  },
  created(){
    this.getAuthPersons()
    this.getLeaveType()
  },
  methods :{
       getAuthPersons(){
         this.AuthOptions.data = [...this.AuthPerson]
       },
       getLeaveType(){
         this.LeaveOptions.data = [...this.LeaveType]
       },
       onCreatedFrom(e) {
        this.$refs.CreatedToDate.data.minDate(e.date)
        },
      applyFilter(){
      var Obj =
      {
        FromDate : this.CreatedFromDate,
        ToDate : this.CreatedToDate,
        LeaveType : this.Type,
        AuthorizedPerson : this.AuthorizedPerson,
        Status : this.Status
      }
        console.log("obj",Obj)
        this.isFilterApplied = true
        this.$parent.getLeaveHistory(Obj, this.isFilterApplied)
        this.$emit('cancel')
    },

      cancelAppliedFilters(){
      this.$emit('cancel')
    },
  }
}
</script>
<style lang="scss" scoped>
@import "~styles/framework/bootstrap/variables";

.task_filter{
  background: $ob-white-color;
  position: relative;
  border: 1px solid $ob-light-gray-1;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  box-shadow: 0 2px 4px 0 $ob-filter-grey;
  position: absolute;
  top: 53px;
  right: 250px;
  width: 527px;
  z-index: 4;
  &:after, &:before{
    bottom: 100%;
    left: 46%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:before {
    border-color: transparent;
    border-bottom-color: $ob-light-gray-1;
    border-width: 13px;
    margin-left: -13px;
  }
  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: $ob-white-color;
    border-width: 12px;
    margin-left: -12px;
  }
  p{
    margin-bottom: 0;
  }
  h4 {
    color: $ob-brand-primary;
  }
  .task-filter__header {
    border-bottom: 1px solid $ob-light-gray-1;
    padding: 10px;
  }
  .task-filter__body {
    background: $ob-white-color;
    padding: 15px;
    max-height: 300px;
      .form-group{
      label{
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        font-weight: 400;
      }
    }
  }
  .task-filter__footer {
    text-align: center;
    background: $ob-white-color;
    margin: 0;
    border-top: 1px solid $ob-light-gray-1;
    padding: 10px;
    button{
      margin: 0 5px;
    }
  }
}
.task_filter1{
  background: $ob-white-color;
  position: relative;
  border: 1px solid $ob-light-gray-1;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  box-shadow: 0 2px 4px 0 $ob-filter-grey;
  position: absolute;
  top: 38px;
  right:20px;
//   left: 58px;
  width: 735px;
  z-index: 4;
  &:after, &:before{
    bottom: 100%;
    right: 23px;
    // left: 46%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:before {
    border-color: transparent;
    border-bottom-color: $ob-light-gray-1;
    border-width: 13px;
    margin-left: -13px;
  }
  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: $ob-white-color;
    border-width: 12px;
    margin-left: -12px;
  }
  p{
    margin-bottom: 0;
  }
  h4 {
    color: $ob-brand-primary;
  }
  .task-filter__header {
    border-bottom: 1px solid $ob-light-gray-1;
    padding: 10px;
  }
  .task-filter__body {
    background: $ob-white-color;
    padding: 15px;
    max-height: 300px;
      .form-group{
      label{
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        font-weight: 400;
      }
    }
  }
  .task-filter__footer {
    text-align: center;
    background: $ob-white-color;
    margin: 0;
    border-top: 1px solid $ob-light-gray-1;
    padding: 10px;
    button{
      margin: 0 5px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/LeaveHistoryFilter.vue